import GameSequenceHelper from './game_sequence_helper';

export default class GameStepInserter extends GameSequenceHelper {
    static CLASS = 'GameStepInserter';

    init(params) {
        super.init(params);

        if(!params.newSteps) {
            this.throwArgumentExpected('10', 'init', 'newSteps');
        }

        this._newSteps = params.newSteps;
    }

    last() {
        this._newSteps.forEach((step) => {
            this._currentSteps.push(step);
        });

        return this._createNewGameSequenceBuilder();
    }

    first() {
        this._currentSteps.splice(0, 0, ...this._newSteps);
        return this._createNewGameSequenceBuilder();
    }

    before(gameStepPrototype) {
        this._checkIsGameStep(gameStepPrototype);
        let index = this._findStepIndex(gameStepPrototype);
        if(index < 0) {
            this.throwError('33', `Cannot insert before because there is no game step of type ${gameStepPrototype}`);
        }
        this._currentSteps.splice(index, 0, ...this._newSteps);
        return this._createNewGameSequenceBuilder();
    }

    after(gameStepPrototype) {
        this._checkIsGameStep(gameStepPrototype);

        let index = this._findStepIndex(gameStepPrototype);
        if(index < 0) {
            this.throwError('44', `Cannot insert after because there is no game step of type ${gameStepPrototype}`);
        }
        this._currentSteps.splice(index + 1, 0, ...this._newSteps);
        return this._createNewGameSequenceBuilder();
    }
}